export const environment = {
  production: true,
  chatSocketServer: 'https://demoapi.kachiing.com/socket.io',
  baseUrl: 'https://demo.kachiing.com/',
  baseUrlAdmin: 'https://demoapi.kachiing.com/adminApp/',
  ImageUrl: 'https://demoapi.kachiing.com/',
  paypalClientId:
    'ASkeUiOmMALMGIDu3v3w5-u2dXrq-rH2RDZYgIPfKuSx7LaTSG9NIvzbiNTzYzfoF893zDylJEgH2O02',
  paypalPlanId: 'P-4J20613518231261SMHJI7KQ',
  whtsappCloudUrl: 'https://graph.facebook.com/v15.0/106218345699617/messages',
  whtsappCloudToken:
    'EAAHMiNKkKV4BANnUGqjn8f7rtPSI8w2mdlCZBW2ZAZBXIrZCNiFKNmsLqDI9t9vzMKcZAtuVKhVBFdsq0xtBc4Hnm9nHREyiNXy8ukoElBBGe0G8u1HAPM5Hp3Gsl1920pZCYDPfxUj33BRCXEPiq6dRMVIkmvHF2XXfQewTaT3D6sqqH07gZAehVYJsfKjFZA4EqOgW5CMLYAZDZD',
};
